<script>
      import { onMount } from "svelte"; // Importamos onMount un método que utilizaremos para detectar cuándo esta montado el componente.
      import GChar from './GChar.svelte'

	  // Creamos una constate API con la URL de la API publica
     // const API = "https://spreadsheets.google.com/feeds/cells/1nMm9pglvIo3ZHm5dmbPkxT_MlzZNi9K71cgANTQYpeE/1/public/full?alt=json";
      const API = "https://spreadsheets.google.com/feeds/cells/1nMm9pglvIo3ZHm5dmbPkxT_MlzZNi9K71cgANTQYpeE/1/public/values?alt=json";

      //const API = "https://drive.google.com/file/d/19yc-9LRuDYRtN2nAvW-_Ta9MP592k9gE/view?usp=sharing";
      //const API = "../tmena.json";

      // Asignamos la variable "data" y "characters" como arreglos vacíos.
      let data = [];
      let characters = [];

      // Utilizamos el método onMount para crear lógica una vez que se haya montado en el DOM el componente
      onMount(async () => {
    	// Creamos un llamado a la API por medio de Fetch
        const res = await fetch(API);
    	// Utilizamos "data" para asignar el resultado de la llamada
        data = await res.json();
    	// Cargamos a characters el resultado de los personajes
        characters = data;
      });
</script>

    <style>
      .characters {
        width: 100%;
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        grid-gap: 8px;
      }
      figure,

      img {
        width: 100%;
        margin: 1;
      }
    </style>

    <div class="characters">
      <ol>
      {#each characters as character, i }
          <li>
            Valor: {i}
          </li>
          <hr>
      {:else}
        <p>loading...</p>
      {/each}
      <hr>
      </ol>
    </div>